import { render, staticRenderFns } from "./audits-table.vue?vue&type=template&id=dcc7899c&scoped=true"
import script from "./audits-table.vue?vue&type=script&lang=js"
export * from "./audits-table.vue?vue&type=script&lang=js"
import style0 from "./audits-table.vue?vue&type=style&index=0&id=dcc7899c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc7899c",
  null
  
)

export default component.exports